<template>
  <nuttrema-layout-schedules
     class="nuttrema-layout-schedules__central__middle--no-margin-top is-east-scroll"
     width-west="20em"
     width-east="20em"
     min-width-west="2em"
     min-width-east="2em"
    :show-east="true">

      <div
        slot="west"
        class="section-nutrition-information">
        <nuttrema-layout-three-vertical>
          <aside
            slot="top"
            class="menu menu--nuttrema-cred-layout">
            <p class="menu-label">{{ $t('label.nutrition_groups') }}</p>
            <ul class="menu-list">
              <li v-for="nutrientGroup in nutrientGroups" :key="nutrientGroup.code">
                <a
                  :class="{ 'is-active': checkIsGroupSelected(nutrientGroup.code) }"
                  @click="handleChangeSelectedGroup(nutrientGroup.code)">
                  {{ nutrientGroup.name }}
                </a>
              </li>
            </ul>
          </aside>

          <div slot="bottom" v-if="showManually && type !== keys.meal" class="section-manually">
            <permissions-control-wrapper
               action="label.enter_manually"
              :required-general="$PERMISSIONS_GENERAL.EDIT"
              :permissions="_get(StuffToEatDetails, 'meta.permissions')">
              <template slot="allowed">
                <el-popover
                  width="255"
                  trigger="hover"
                  placement="top-start"
                  popper-class="el-popover--fix-break">
                  <span>{{ $t('label.custom_nutrition_information_note') }}</span>
                  <template slot="reference">
                    <el-button
                      class="w-100" :type="options.setManually ? 'nuttrema-orange' : 'info'"
                      @click="toggleSetManually">
                      {{ $t('label.enter_manually') }}: <strong>{{ options.setManually ? $t('label.on') : $t('label.off') }}</strong>
                    </el-button>
                  </template>
                </el-popover>
              </template>

              <template slot="not-allowed">
                <el-button
                  type="info"
                  class="w-100 is-icon-mr-075">
                  <i class="far fa-lock-alt"></i>{{ $t('label.enter_manually') }}: <strong>{{ options.setManually ? $t('label.on') : $t('label.off') }}</strong>
                </el-button>
              </template>
            </permissions-control-wrapper>
          </div>
          <!-- end ~ section-manually -->

        </nuttrema-layout-three-vertical>
      </div>

      <div slot="west-fold">
        <div class="section-nutrition-information is-fold">
          <div class="vertical-menu-label">
            <p class="is-left">{{ $t('label.nutrition_groups') }}</p>
          </div>
        </div>
      </div>

      <!-- form -->
      <div
          slot="central"
          class="form-standard-layout form-standard-layout--food-product-nutrition-information">

        <div class="form-standard-layout__content">

          <div
             class="nutrition-information"
             ref="reference-nutrition-information"
            :class="tableClass">
            <resize-observer @notify="onResize"></resize-observer>
            <ul>
              <li v-for="nutrientDefinitionFirstLevel in nutrientDefinitions" :key="nutrientDefinitionFirstLevel.id">
                  <div class="list-item" :class="{
                    'is-last': isLast(nutrientDefinitions, nutrientDefinitionFirstLevel),
                    'is-no-more': isEmpty(nutrientDefinitionFirstLevel.NutrientDefinition) }">
                    <div class="list-label">
                      <h5>{{ nutrientDefinitionFirstLevel.name }}</h5>
                    </div>
                    <div class="list-input" :class="{ 'is-not-defined': !nutritionInformation[nutrientDefinitionFirstLevel.code].defined }">
                      <template v-if="edit">
                        <el-switch
                          v-model="nutritionInformation[nutrientDefinitionFirstLevel.code].defined">
                        </el-switch>
                        <el-input-number
                           v-show="edit"
                           v-model="nutritionInformation[nutrientDefinitionFirstLevel.code].value"
                           size="mini"
                          :disabled="!nutritionInformation[nutrientDefinitionFirstLevel.code].defined"
                          :debounce="500"
                          :step="0.5">
                        </el-input-number>
                      </template>
                      <template v-else>
                        <span class="value" v-if="nutritionInformation[nutrientDefinitionFirstLevel.code].defined">{{ nutritionInformation[nutrientDefinitionFirstLevel.code].value | number-format(2) }}</span>
                        <span class="value" v-else>~</span>
                      </template>
                      <span class="unit">{{ nutrientDefinitionFirstLevel.unit }}</span>
                    </div>
                  </div>

                  <ul>
                    <li v-for="nutrientDefinitionSecondLevel in nutrientDefinitionFirstLevel.NutrientDefinition" :key="nutrientDefinitionSecondLevel.id">
                      <div class="list-item" :class="{
                        'is-last': isLast(nutrientDefinitionFirstLevel.NutrientDefinition, nutrientDefinitionSecondLevel),
                        'is-no-more': isEmpty(nutrientDefinitionSecondLevel.NutrientDefinition) }">
                        <div class="list-label">
                          <h5>{{ nutrientDefinitionSecondLevel.name }}</h5>
                        </div>
                        <div class="list-input" :class="{ 'is-not-defined': !nutritionInformation[nutrientDefinitionSecondLevel.code].defined }">
                          <template v-if="edit">
                            <el-switch
                              v-model="nutritionInformation[nutrientDefinitionSecondLevel.code].defined">
                            </el-switch>
                            <el-input-number
                               v-show="edit"
                               v-model="nutritionInformation[nutrientDefinitionSecondLevel.code].value"
                               size="mini"
                              :disabled="!nutritionInformation[nutrientDefinitionSecondLevel.code].defined"
                              :debounce="500"
                              :step="0.5">
                            </el-input-number>
                          </template>
                          <template v-else>
                            <span class="value" v-if="nutritionInformation[nutrientDefinitionSecondLevel.code].defined">{{ nutritionInformation[nutrientDefinitionSecondLevel.code].value | number-format(2) }}</span>
                            <span class="value" v-else>~</span>
                          </template>
                          <span class="unit">{{ nutrientDefinitionSecondLevel.unit }}</span>
                        </div>
                      </div>

                      <ul>
                        <li v-for="nutrientDefinitionThirdLevel in nutrientDefinitionSecondLevel.NutrientDefinition" :key="nutrientDefinitionThirdLevel.id">
                          <div class="list-item" :class="{
                            'is-last': isLast(nutrientDefinitionSecondLevel.NutrientDefinition, nutrientDefinitionThirdLevel),
                            'is-no-more': isEmpty(nutrientDefinitionFirstLevel.NutrientDefinition) }">
                            <div class="list-label">
                              <h5>{{ nutrientDefinitionThirdLevel.name }}</h5>
                            </div>
                            <div class="list-input" :class="{ 'is-not-defined': !nutritionInformation[nutrientDefinitionThirdLevel.code].defined }">
                              <template v-if="edit">
                                <el-switch
                                  v-model="nutritionInformation[nutrientDefinitionThirdLevel.code].defined">
                                </el-switch>
                                <el-input-number
                                   v-show="edit"
                                   v-model="nutritionInformation[nutrientDefinitionThirdLevel.code].value"
                                   size="mini"
                                  :disabled="!nutritionInformation[nutrientDefinitionThirdLevel.code].defined"
                                  :debounce="500"
                                  :step="0.5">
                                </el-input-number>
                              </template>
                              <template v-else>
                                <span class="value" v-if="nutritionInformation[nutrientDefinitionThirdLevel.code].defined">{{ nutritionInformation[nutrientDefinitionThirdLevel.code].value | number-format(2) }}</span>
                                <span class="value" v-else>~</span>
                              </template>
                              <span class="unit">{{ nutrientDefinitionThirdLevel.unit }}</span>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <!-- end ~ nutrientDefinitionThirdLevel -->

                    </li>
                  </ul>
                  <!-- end ~ nutrientDefinitionSecondLevel -->

              </li>
            </ul>
            <!-- end ~ nutrientDefinitionFirstLevel -->
          </div>
          <!-- end ~ nutrition-information -->



        </div>
        <!-- end ~ nuttrema-cred-layout__content -->

        <div class="form-standard-layout__footer" v-if="edit">
          <div class="form-standard-layout__footer-actions">
            <nav class="level">
              <div class="level-left">
                <el-button
                   type="primary"
                   size="small"
                  :loading="_get(StuffToEatNutritionInformation, 'saving')"
                  @click="submitForm()">{{ $t('label.save_changes') }}
                </el-button>
              </div>
              <div class="level-right">
                <el-button type="text" size="small" @click="cancelChanges('food-product-main-details')">
                  <span v-if="_get(StuffToEatNutritionInformation, 'saved')">{{ $t('label.done') }}</span>
                  <span v-else>{{ $t('label.cancel') }}</span>
                </el-button>
              </div>
            </nav>
          </div>
        </div>
        <!-- end ~ form-standard-layout__footer -->

      </div>
      <!-- end ~ form -->

      <div slot="east" class="section-nutrition-facts">
        <nuttrema-loader
          v-if="StuffToEatNutritionFactsLabel.fetching"
          theme="transparent">
        </nuttrema-loader>

        <nutrition-facts-realtime
           v-else
          :showDownload="true"
          :permissions="_get(StuffToEatDetails, 'meta.permissions')"
          :nutritionInformation="nutritionInformation"
          :productNutritionFacts="StuffToEatNutritionFactsLabel.data"
          @downloadPDF="onDownloadPDF">
        </nutrition-facts-realtime>
      </div>

      <div slot="east-fold">
        <div class="section-nutrition-information is-fold">
          <div class="vertical-menu-label">
            <p>{{ $t('label.nutrition_information') }}</p>
          </div>
        </div>
      </div>

    </nuttrema-layout-schedules>
</template>

<script>
import Vue from 'vue';
import { ResizeObserver } from 'vue-resize';
import { find, each, isEmpty, has, cloneDeep, last, isNil } from 'lodash';

import { STUFF_TO_EAT_KEYS } from 'constants/types';

import NuttremaLayoutSchedules from 'components/ui/layout/nuttrema-layout-schedules';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import NutritionFactsRealtime from 'components/ui/nutrition-information/nutrition-facts-realtime';
import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  name: 'form-food-product-nutrition-information',
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    StuffToEatDetails: {
      type: Object,
      required: true,
      default: null,
    },
    StuffToEatNutritionInformation: {
      type: Object,
      required: false,
      default: null,
    },
    productNutritionInformation: {
      type: Array,
      required: true,
      default: null,
    },
    StuffToEatNutritionFactsLabel: {
      type: Object,
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    setManually: {
      type: Boolean,
      required: true,
      default: false,
    },
    showManually: {
      type: Boolean,
      required: false,
      default: true,
    },
    type: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      nutrientGroups: [],
      nutritionInformation: {},
      selectedNutrientGroup: null,
      originalNutritionInformation: {},
      options: {
        setManually: null,
        showPageLabelsPopover: false,
      },
      keys: {
        meal: STUFF_TO_EAT_KEYS.meal,
      },
      tableClass: null,
    };
  },
  components: {
    NuttremaLoader,
    ResizeObserver,
    NuttremaEmptyResult,
    NutritionFactsRealtime,
    NuttremaLayoutSchedules,
    NuttremaLayoutThreeVertical,
  },
  computed: {
    nutrientDefinitions() {
      const group = find(this.productNutritionInformation, item => item.code === this.selectedNutrientGroup);
      return group.NutrientDefinition;
    },
    enteredNutritionInformation() {
      const entered = {
        nutrition_information: [],
      };
      each(this.nutritionInformation, (item) => {
        if (!isNil(item.value) && item.defined) {
          const value = item.value !== '' ? item.value : 0;
          entered.nutrition_information.push({
            nutrient_definition_id: item.id,
            nutrition_value: value,
          });
        }
      });
      return entered;
    },
  },
  methods: {
    isEmpty(array) {
      return isEmpty(array);
    },
    isLast(array, item) {
      return last(array) === item;
    },
    handleChangeSelectedGroup(code) {
      this.selectedNutrientGroup = code;
    },
    checkIsGroupSelected(code) {
      return code === this.selectedNutrientGroup;
    },
    findNutrientGroups() {
      let i;
      for (i = 0; i < this.productNutritionInformation.length; i += 1) {
        const item = this.productNutritionInformation[i];
        if (i === 0) this.selectedNutrientGroup = item.code;
        this.nutrientGroups.push({
          id: item.id,
          code: item.code,
          name: item.name,
        });
      }
      if (!isEmpty(this.productNutritionInformation)) {
        this.mapNutritionInformation(this.productNutritionInformation);
      }
    },
    mapNutritionInformation(data) {
      each(data, (item) => {
        if (has(item, 'NutritionInformation')) {
          Vue.set(this.nutritionInformation, item.code, {
            id: item.id,
            value: item.NutritionInformation.nutrition_value,
            defined: item.NutritionInformation.nutrition_value !== '',
          });
        }
        if (!isEmpty(item.NutrientDefinition)) this.mapNutritionInformation(item.NutrientDefinition);
      });
    },
    cancelChanges() {
      this.nutritionInformation = cloneDeep(this.originalNutritionInformation);
      this.$emit('update:edit', false);
    },
    toggleSetManually() {
      this.options.setManually = !this.options.setManually;
      this.$emit('update:setManually', this.options.setManually);
      this.$emit('changeManualControl', this.options.setManually);
    },
    submitForm() {
      this.$emit('submit', this.enteredNutritionInformation);
    },
    onDownloadPDF(servingSizeID, action) {
      this.$emit('downloadPDF', servingSizeID, action);
    },
    onResize() {
      const width = this.$refs['reference-nutrition-information'].scrollWidth;
      this.tableClass = width <= 400 ? 'two-line' : 'regular';
    },
  },
  created() {
    this.findNutrientGroups();
    // make copy of original data
    this.options.setManually = this.setManually;
    this.originalNutritionInformation = cloneDeep(this.nutritionInformation);

    // Set table class
    this.$nextTick(() => {
      this.onResize();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/theme/colors';
@import '~styles/mixins/mixins';

.form-standard-layout--food-product-nutrition-information {
  .form-standard-layout__content {
    padding: 0;
    display: flex;
    flex-grow: 1;
    align-self: stretch;
    overflow-y: hidden;
  }
}

.section-nutrition-information {
  height: 100vh;
  padding: 0.5em;
  overflow-y: auto;
  position: relative;
  background-color: $nutrition-facts-orange-light-bg;
  &.is-fold {
    padding: 0.75em 0.35em;
  }
  @supports (-moz-appearance: none) {
    height: calc(100vh - 60px);
  }
}

.section-nutrition-facts {
  height: 100vh;
  padding: 0 0.75em;
  background-color: $nutrition-facts-orange-light-bg;
  @supports (-moz-appearance: none) {
    height: calc(100vh - 60px);
  }
}

.section-manually {
  width: 100%;
  .el-switch {
    float: right;
  }
}

.vertical-menu-label {
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  p {
    color: #7a7a7a;
    font-size: 0.8em;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    &.is-left {
      transform: scale(-1);
    }
  }
}

.menu--nuttrema-cred-layout {
  width: 100%;
}

.nutrition-information {
  padding: 0 1.5em;
  overflow-y: auto;

  ul {
    list-style: none;
    padding: 0;
    margin: 1em 0;
    li {
      padding: 0;
      margin: 0;
      display: block;
      width: 100%;

      .list-item {
        display: table;
        table-layout: fixed;
        width: 100%;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 1px 0;
        &.is-last.is-no-more {
          border-bottom: none;
        }
      }

      .list-label,
      .list-input {
        display: table-cell;
        width: 50%;
        padding: 0.5em 1em;
        vertical-align: middle;
        &.is-not-defined {
          span.value,
          span.unit {
            color: $element-ui-color-plain;
          }
        }
      }

      .list-label {
        text-align: left;
      }

      .list-input {
        text-align: right;
        font-size: 14px;
        .el-switch {
          margin-right: 0.5em;
        }
        span.value {
          display: inline-block;
          text-align: right;
          vertical-align: middle;
          font-weight: 600;
          line-height: 30px;
        }
        span.unit {
          width: 1.5em;
          display: inline-block;
          text-align: left;
          vertical-align: middle;
        }
        .el-input-number {
          vertical-align: middle;
          margin-right: 0.5em;
        }
      }
    }
  }

  > ul {
    margin: 0;
  }

  > ul > li {
    > .list-item .list-label {
      > * {
        font-weight: 500;
      }
    }

    > ul {
      .list-item {
        padding-left: 1em;
        .list-label {
          color: $gray-dark;
        }
      }
    }
  }

  > ul > li > ul > li {
    > ul {
      .list-item {
        padding-left: 2em;
        .list-label {
          color: $gray;
        }
      }
    }
  }

  > ul > li > ul > li > ul > li > ul {
    .list-item {
      padding-left: 3em;
    }
  }

  > ul > li > .list-item {
    .list-label {
      font-weight: 800;
    }
  }

  &.two-line {
    .list-label,
    .list-input {
      width: 100%;
      display: inline-block;
    }
    // .list-label {
    //   padding-bottom: 0;
    // }
    .list-input {
      padding-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/nutrition-information/form-food-product-nutrition-information.vue